/* eslint-disable no-nested-ternary */
import { any, array, bool, func, string } from "prop-types";
import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import OnboardingListItem from "../../../components/OnboardingListItem/OnboardingListItem";
import ReadingListDownload from "../../../components/ReadingListDownload";
import ReadingStatus from "../../../components/ReadingListDownload/reading_status";
import * as style from "../styles.module.scss";
import ProfileImageUpload from "../../../containers/ProfileImage";

const getImportantMsg = (documentTitle) => {
  if (
    [
      "Company Induction",
      "Raising Concerns and Grievances",
      "Welcome Booklet",
    ].includes(documentTitle)
  )
    return "Important";

  return "";
};

const getMsg = (documentTitle) => {
  if (
    [
      "Company Induction",
      "Raising Concerns and Grievances",
      "Welcome Booklet",
    ].includes(documentTitle)
  )
    return "Please read immediately.";

  if (
    ["Manual Handling", "Safety Knives", "Modern Slavery"].includes(
      documentTitle
    )
  )
    return "Please read within one week of your induction.";

  if (
    [
      "Anti Bribery and Corruption Overview",
      "Ethics Overview",
      "Human Rights Overview",
    ].includes(documentTitle)
  )
    return "Please read within two weeks of your induction.";

  return "";
};

const determineLeftSide = (status, submitted) => {
  if (submitted) {
    return 3;
  }
  if (status === 2) {
    return 4;
  }
  return status;
};

const OnboardingSection = ({
  appData,
  title,
  subtext = "",
  formsListWithStatus,
  readingListWithStatus,
  submitted,
  submit,
  currentlyReading,
  setCurrentlyReading,
  markDocumentRead,
  isLoading,
  hasSignatureUpload,
  fileUploadDesc = "",
  fileUploadTitle = "",
  fileUploadKey = "",
  fileUpload = false,
  fileUploadCond = false,
  imageFileKey = "",
}) => {
  return (
    <div className={`${style.readingList__wrapper} section-body pt-1 bg-white`}>
      {title ? <h5 className="px-1">{title}</h5> : null}
      {typeof subtext === "object" ? (
        subtext.map((row) => (
          <p key={row} className="px-1" style={{ width: "90%" }}>
            {row}
          </p>
        ))
      ) : subtext ? (
        <p className="p-1" style={{ width: "90%" }}>
          {subtext}
        </p>
      ) : null}
      {formsListWithStatus &&
        formsListWithStatus.map((elem) => (
          <OnboardingListItem
            title={elem.title}
            status={determineLeftSide(elem.status, submitted || elem.submitted)}
            key={elem.title}
            handleClick={elem.handleClick}
            disabled={elem.disabled}
            loading={elem.loading}
            downloadingDisabled={elem.downloadingDisabled}
            customButton={elem.customButton}
            subtitle={elem.description}
            submitted={elem.submitted || false}
            retry={elem.retry}
            btnText={
              elem.text
                ? elem.text
                : elem.status === ReadingStatus.Todo
                ? "Enter Details"
                : "Edit"
            }
            url={elem.url}
          />
        ))}
      {readingListWithStatus &&
        readingListWithStatus.map((elem, i) => (
          <ReadingListDownload // ===| title, link, agreementText, noDownload, status |===
            key={i}
            title={elem.title}
            onFly={elem.onFly}
            description={elem.description}
            link={elem.link}
            status={elem.status}
            currentlyReading={currentlyReading}
            setCurrentlyReading={setCurrentlyReading}
            markDocumentRead={markDocumentRead}
            // getCompletedDocument={getCompletedDocument}
            // downloadedPdfs={downloadedPdfs}
            noCheckBoxConsent={elem.noCheckBoxConsent}
            isCustom={true}
            isLoading={isLoading}
            customAgreements={elem && elem.customAgreements}
            agreementText={elem && elem.agreementText}
            isPusterla={true}
            importantMsg={
              elem.status === ReadingStatus.Todo
                ? getImportantMsg(elem.title)
                : ""
            }
            msg={elem.status === ReadingStatus.Todo ? getMsg(elem.title) : ""}
          />
        ))}
      {submit()}
      {fileUpload ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            padding: "1rem",
          }}
        >
          <div
            className={`${style.readingList__wrapper} section-body bg-white p-1 my-1 mt-lg-0`}
          >
            <h5 className="">{fileUploadTitle}</h5>
            <div>
              {fileUploadDesc}
              <br />
            </div>
            {fileUploadCond && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  color: "green",
                  padding: "1rem",
                }}
              >
                Thank you, your upload has been saved.
              </div>
            )}
            <Fragment>
              <ProfileImageUpload
                showHeader={false}
                imageFileKey={imageFileKey}
                redirectAfterSave={false}
                text={fileUploadTitle}
                isABM={true} // doesn't need to be for each client
              />
            </Fragment>
          </div>
        </div>
      ) : null}
      {hasSignatureUpload ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            padding: "1rem",
          }}
        >
          <div
            className={`${style.readingList__wrapper} section-body bg-white p-1 my-1 mt-lg-0`}
          >
            <h5 className="px-2">Upload Signed Declaration Page</h5>
            <div>
              Please download and print pages 7 & 8 (Declarations) of your
              onboarding form and then sign all four declarations. Please then
              take a picture of page 7 and a picture of page 8, ensuring it is a
              straight picture and the whole form is included in the picture
              (must be able to see all 4 corners of the page). Upload both
              pictures below.
              <br />
            </div>
            {appData.abmOnboarding && // todo make generic
              appData.abmOnboarding.abmDeclaration && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "green",
                    padding: "1rem",
                  }}
                >
                  Thank you, your page 7 declaration has been saved.
                </div>
              )}
            <Fragment>
              <ProfileImageUpload
                showHeader={false}
                imageFileKey={`abmDeclaration`}
                redirectAfterSave={false}
                text="Page 7 declaration"
                isABM={true}
              />
            </Fragment>
            {appData.abmOnboarding && // todo make generic
              appData.abmOnboarding.abmDeclaration2 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "green",
                    padding: "1rem",
                  }}
                >
                  Thank you, your page 8 declaration has been saved.
                </div>
              )}
            <Fragment>
              <ProfileImageUpload
                showHeader={false}
                imageFileKey={`abmDeclaration2`}
                redirectAfterSave={false}
                text="Page 8 declaration"
                isABM={true}
              />
            </Fragment>
          </div>
        </div>
      ) : null}
    </div>
  );
};

OnboardingSection.propTypes = {
  appData: any,
  title: string,
  subtext: string,
  formsListWithStatus: array,
  readingListWithStatus: array,
  submitted: bool,
  submit: any,
  currentlyReading: bool,
  setCurrentlyReading: func,
  markDocumentRead: func,
  isLoading: bool,
  hasSignatureUpload: bool,
  fileUploadCond: bool,
  fileUpload: bool,
  fileUploadDesc: string,
  fileUploadTitle: string,
  fileUploadKey: string,
  imageFileKey: string,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(OnboardingSection);
